import { Table } from "react-bootstrap"
import { TableWrapper } from "./styles"


export const RenderTable = ({children}) => {
    return(
        <TableWrapper>
            <Table borderless>
                {children}
            </Table>
        </TableWrapper>
    )
    
}